import script from "./model3d.vue?vue&type=script&setup=true&name=model3d&lang=js"
export * from "./model3d.vue?vue&type=script&setup=true&name=model3d&lang=js"

import "./model3d.vue?vue&type=style&index=0&id=66fda303&lang=css"

const __exports__ = script;

export default __exports__